declare global {
    interface Window {
        OneTrust?: {
            GetDomainData: () => {
                ConsentModel?: {
                    Name?: string;
                };
            };
        };
        registerCookieComplianceCallback: (params: {
            callback: () => void;
            category?: 'necessary' | 'functional' | 'performance' | 'targeting';
            rejectCallback?: () => unknown;
            pendingCallback?: () => unknown;
            isCallOptanonWrapper?: boolean;
        }) => void;
    }
}

const toggleDisplayCookiePreferencesButtonByLocation = () => {
    const cookiePreferencesFooterButton =
        document.querySelector('#ot-sdk-btn')?.parentElement;
    if (!cookiePreferencesFooterButton) return;

    // Button is shown for any active OneTrust jurisdiction: opt-out (US states with privacy laws; "custom" consent model
    // in the California template Geolocation config) and opt-in (GDPR, Quebec Law 25)
    const consentModel = window.OneTrust?.GetDomainData()?.ConsentModel?.Name;

    if (consentModel && consentModel !== 'notice only') {
        cookiePreferencesFooterButton.classList.remove('tw:hidden');
    }
};

const initCookiePreferencesButton = () => {
    window.registerCookieComplianceCallback({
        callback: toggleDisplayCookiePreferencesButtonByLocation,
    });
};

export { initCookiePreferencesButton };
